import * as React from 'react';
import * as actions from './ReceivableActions';
import { ILegalEntity } from './Types';
import { connect } from 'react-redux';
import { handleError } from '../../shared/ErrorCatching';
import { Tab, Nav, NavItem } from 'react-bootstrap';
import ReceivablePage from './ReceivablePage';

interface IActions {
    getInitialData: () => Promise<any>;
    resetState: () => any;
}

interface IProps {
    actions: IActions;
    legalEntities: ILegalEntity[];
}

interface IState {}

class ReceivablesPage extends React.Component<IProps, IState> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            legalEntityStates: []
        };
    }

    componentDidMount(): void {
        this.props.actions.getInitialData().catch((error: any) => handleError(error));
    }

    componentWillUnmount() {
        this.props.actions.resetState();
    }

    render() {
        return (
            <Tab.Container defaultActiveKey={0} id="uncontrolled-tab">
                <div>
                    <Nav bsStyle="tabs">
                        {this.props.legalEntities.map((x: ILegalEntity, index: number) => (
                            <NavItem eventKey={index} key={'legal-entity-nav-item-' + index}>
                                {x.name}
                            </NavItem>
                        ))}
                    </Nav>
                    <Tab.Content>
                        {this.props.legalEntities.map((x: ILegalEntity, index: number) => (
                            <Tab.Pane eventKey={index} key={'legal-entity-tab-' + index}>
                                <ReceivablePage legalEntityId={x.id} />
                            </Tab.Pane>
                        ))}
                    </Tab.Content>
                </div>
            </Tab.Container>
        );
    }
}

function mapStateToProps(state: any, ownProps: IProps) {
    return {
        legalEntities: state.receivable.legalEntities
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getInitialData: () => dispatch(actions.getInitialData()),
            resetState: () => dispatch(actions.resetState())
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReceivablesPage);
